import badgeBanner from "../../../assets/images/trophies/badge-banner.png";

const CategoriesSection = () => {
  return (
    <section className="block categories-section">
      <div className="wrap">
        <div className="section-head">
          <h2>
            Deux <span className="accent">catégories</span>.
          </h2>
        </div>
        <div className="cats">
          <img
            className="badge"
            src={badgeBanner}
            loading="lazy"
            alt="Trophées des véhicules électriques 2026 — Meilleure citadine et meilleure familiale électrique"
          />
        </div>
      </div>
    </section>
  );
};

export default CategoriesSection;
